import React, { createContext, useContext, useState, useEffect } from 'react';
import { DateTime, Settings } from 'luxon';

// Configuration globale de Luxon pour utiliser UTC
Settings.defaultZone = 'utc';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // Charger depuis localStorage de manière synchrone au démarrage
  const [cartItems, setCartItems] = useState(() => {
    try {
      const savedCart = localStorage.getItem('vitasecours_cart');
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (error) {
      console.error('Erreur lors de la lecture du panier:', error);
      return [];
    }
  });

  // Sauvegarder le panier dans localStorage à chaque modification
  useEffect(() => {
    localStorage.setItem('vitasecours_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  // Ajouter un article au panier
  const addToCart = (item) => {
    const cartItem = {
      id: Date.now(), // ID unique pour chaque élément du panier
      ...item,
      addedAt: DateTime.now().toISO()
    };
    setCartItems([...cartItems, cartItem]);
  };

  // Supprimer un article du panier
  const removeFromCart = (id) => {
    setCartItems(cartItems.filter(item => item.id !== id));
  };

  // Vider le panier
  const clearCart = () => {
    setCartItems([]);
  };

  // Obtenir le nombre d'articles dans le panier
  const getCartCount = () => {
    return cartItems.length;
  };

  // Obtenir le contenu du panier formaté
  const getCartItems = () => {
    return cartItems;
  };

  const value = {
    cartItems,
    addToCart,
    removeFromCart,
    clearCart,
    getCartCount,
    getCartItems,
    setCartItems
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart doit être utilisé dans un CartProvider');
  }
  return context;
};
